var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card abtg__default-card abtg__default-card-border"},[_c('div',{staticClass:"card-head"},[_c('header')]),_vm._v(" "),_c('div',{staticClass:"card-body"}),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"float-right"})])])])])
}]

export { render, staticRenderFns }